import { combineReducers } from 'redux';

import applicationReducer from './nodes/application/reducer';
import authenticationReducer from './nodes/authentication/reducer';
import entitiesReducer from './nodes/entities/reducer';
import featuresReducer from './nodes/features/reducer';
import notificationReducer from './nodes/notification/reducer';
import routerReducer from './nodes/router/reducer';
import utilsReducer from './nodes/utils/reducer';

export default combineReducers({
  application: applicationReducer,
  authentication: authenticationReducer,
  entities: entitiesReducer,
  features: featuresReducer,
  notification: notificationReducer,
  router: routerReducer,
  utils: utilsReducer,
});
